import { useEffect, useState, useRef } from 'react';
import { I18n } from 'aws-amplify';
import {
    Button,
    ClickAwayListener,
    Grow,
    Paper,
    Popper,
    MenuItem,
    MenuList,
    Tooltip
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { handleStatusBulkActionTooltipMsg } from '../handler/ListTicketKnowledgeHandler';

function BulkActionDropdown ({ bulkActionList, handleAction, disableBulkBtn, pendingBulkBtn }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    const prevOpen = useRef(open);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <div>
            <Tooltip
                title={`${I18n.get('MSG-KNOW-TOOLTIP-BULK-ACTION-1')}`}
                placement="top"
                arrow
            >
                <span>
                    <Button
                        ref={anchorRef}
                        id="composition-button"
                        aria-controls={open ? 'composition-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        size="small"
                        variant="contained"
                        endIcon={<ExpandMoreIcon style={{ color: '#2D72D2' }} />}
                        style={{ backgroundColor: '#ECF2FB', color: '#2D72D2', boxShadow: 'none' }}
                        disabled={pendingBulkBtn || disableBulkBtn}
                    >
                        一括操作
                    </Button>
                </span>
            </Tooltip>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: 'bottom right',
                            zIndex: 1000,
                            position: 'absolute',
                            minWidth: '160px'
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    className='composition-menu-root'
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}
                                >
                                    {bulkActionList.map(action => {
                                        return (
                                            <Tooltip
                                                key={action.type}
                                                title={`${I18n.get(handleStatusBulkActionTooltipMsg(action.type, !action.disable))}`}
                                                placement="right-end"
                                                arrow
                                            >
                                                <span>
                                                    <MenuItem
                                                        key={action.type}
                                                        value={action.type}
                                                        onClick={e => {
                                                            handleAction(action.type);
                                                            handleClose(e);
                                                        }}
                                                        disabled={action.disable}
                                                    >
                                                        <p
                                                            style={{
                                                                color: action.disable
                                                                    ? '#BABDC5'
                                                                    : '#2E3138'
                                                            }}
                                                        >
                                                            {I18n.get(`${action.type}`)}
                                                        </p>
                                                    </MenuItem>
                                                </span>
                                            </Tooltip>
                                        );
                                    })}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
};

export default BulkActionDropdown;
